var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSteeringWheelColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5134_352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C6.61384 0.00258081 4.32616 0.951621 2.63889 2.63889C0.951621 4.32616 0.00258081 6.61384 0 9C0.45 20.925 17.55 20.9198 18 9C17.9974 6.61384 17.0484 4.32616 15.3611 2.63889C13.6738 0.951621 11.3862 0.00258081 9 0ZM9 1.5C10.5052 1.50163 11.9752 1.95576 13.219 2.80343C14.4628 3.6511 15.423 4.85315 15.975 6.2535L10.518 7.34475C9.48073 7.55175 8.41277 7.55175 7.3755 7.34475L2.0205 6.27375C2.56963 4.86896 3.5292 3.66217 4.77416 2.81066C6.01911 1.95916 7.4917 1.50243 9 1.5ZM1.5 9.08025L4.61625 9.7035C5.04805 9.78988 5.45554 9.97026 5.80979 10.2318C6.16404 10.4934 6.45636 10.8298 6.666 11.217L7.13475 12.0818C7.3714 12.5195 7.49561 13.0091 7.49625 13.5068V16.35C5.81789 16.0037 4.30841 15.0939 3.21839 13.7716C2.12836 12.4492 1.52334 10.7938 1.50375 9.08025H1.5ZM10.5 16.35V13.5098C10.5006 13.0121 10.6249 12.5225 10.8615 12.0848L11.3302 11.22C11.5399 10.8328 11.8322 10.4964 12.1865 10.2348C12.5407 9.97326 12.9482 9.79288 13.38 9.7065L16.5 9.08025C16.48 10.7949 15.874 12.4511 14.7824 13.7736C13.6909 15.0961 12.1797 16.0052 10.5 16.35Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteeringWheelColored);
export default __webpack_public_path__ + "static/media/steering-wheel-colored.3b1923c301786b3a7ed4ca1085e15c0a.svg";
export { ForwardRef as ReactComponent };